import { createModelSchemaWrapper, listOptional, rawCopy } from 'framework/serializr-integration';
import { list, object, primitive } from 'serializr';
import { makeAutoObservable } from 'mobx';

import { AgentState } from 'framework/entities/agentState';
import { AssetTarget } from 'framework/entities/asset';
import { Geotag } from 'framework/entities/geotag';
import { addUniqueNameValidation, ModelValidator } from 'framework/mobx-integration';
import { apiFetch } from 'framework/api';
import { searchAssetsByName } from 'areas/assets/api';

import { AssetHealth } from 'areas/assets/details/types/assetHealth';

export class AssetDetails {
	accountId: string;
	accountName: string;
	agentId: string;
	agentName: string;
	agentState?: AgentState;
	agentStatus: string[];
	assetGroups: string[] = [];
	assetMaintenance: boolean;
	assetType: string;
	calendar: string;
	description: string;
	externalId: string[];
	externalType: string[];
	geotag: Geotag;
	iconPack: string;
	id: string;
	imageId: string;
	indicators: AssetHealth;
	information: string;
	maintenanceCalendars: unknown[];
	modified: number;
	name: string;
	shared: boolean;
	systemType: string = 'GENERIC';
	tags: string[] = [];
	targets: AssetTarget[] = [];

	validator: ModelValidator<AssetDetails>;

	constructor(data?: Partial<AssetDetails>) {
		if (data) {
			Object.assign(this, data);
		}

		makeAutoObservable(this);
	}

	enableValidation() {
		this.validator = new ModelValidator<AssetDetails>(this);

		this.validator.required('name');

		addUniqueNameValidation<AssetDetails>(this, async (name) => {
			const response = await apiFetch(searchAssetsByName(name));

			return response.success && response.data.items.length == 0;
		});
	}
}

createModelSchemaWrapper(AssetDetails, {
	accountId: primitive(),
	accountName: primitive(),
	agentId: primitive(),
	agentName: primitive(),
	agentStatus: listOptional(primitive()),
	agentState: primitive(),
	assetGroups: list(primitive()),
	assetMaintenance: primitive(),
	assetType: primitive(),
	calendar: rawCopy(),
	description: primitive(),
	externalId: list(primitive()),
	externalType: list(primitive()),
	geotag: rawCopy(),
	id: primitive(),
	imageId: primitive(),
	indicators: object(AssetHealth),
	information: primitive(),
	maintenanceCalendars: rawCopy(),
	modified: primitive(),
	name: primitive(),
	shared: primitive(),
	systemType: primitive(),
	tags: list(primitive()),
	targets: list(object(AssetTarget)),
});
